





































































































































































































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import '../assets/css/ServiceRequestDetails.scss';
import '../assets/css/SuccessBox.scss';
import '../assets/css/ConfirmationBox.scss';
import { RequestStatus, ServiceRequest, Route, GPSLocation } from '../types/entity';
import { MedTransGoConstants } from '../util/constants';
import { ObjectFactory } from '../config/objectFactory';
import { DateUtils } from '../util/dateUtils';
import { MathUtils } from '../util/mathUtils';
import GoogleMap from '../components/GoogleMap.vue';
import MessageBox from '../components/MessageBox.vue';
import ConfirmationBox from '../components/ConfirmationBox.vue';
import { required } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import CompleteRequestModal from './modal/CompleteRequestModal.vue';
import AcceptRequestModal from './modal/AcceptRequestModal.vue';
import AssignDriverModal from './modal/AssignDriverModal.vue';
import CompleteRouteModal from './modal/CompleteRouteModal.vue';
import CompleteHomeHealthCareRequestModal from './modal/CompleteHomeHealthCareRequestModal.vue';
import { ApiRequest, CancelRequest } from '@/types/request';
import CompleteCmrRequestModal from './modal/CompleteCmrRequestModal.vue';
import OverlapRequestMessageModel from './modal/OverlapRequestMessageModel.vue';
import { ToastEvent } from '@/types/event';
import { EventBus } from '@/main';
import { CommonUtils } from '@/util/commonUtils';
import { InterpreterProfile } from '@/types/response';
import AssignInterpreterModal from './modal/AssignInterpreterModal.vue';

@Component({
    mixins: [validationMixin],
    props: {
        id: String,
    },
    components: {
        GoogleMap,
        MessageBox,
        ConfirmationBox,
        CompleteRequestModal,
        AssignDriverModal,
        AcceptRequestModal,
        CompleteRouteModal,
        CompleteCmrRequestModal,
        CompleteHomeHealthCareRequestModal,
        OverlapRequestMessageModel,
        AssignInterpreterModal,
    },
    data() {
        return {
            rejectionReason: '',
            reasons: [
                { value: 'R00009', text: 'Appointment Rescheduled' },
                { value: 'R00011', text: 'Incorrect Pick up address provided' },
                { value: 'R00010', text: 'Passenger Provided Own Transportation' },
                { value: 'R00012', text: 'Passenger Refused Transportation' },
                { value: 'R00008', text: 'Passenger Unreachable' },
                { value: 'R00001', text: 'This entry was a test' },
            ],
            rejectionReasons: [
                { value: 'Payout is not sufficient' },
                { value: 'Conflicts with current schedule' },
                { value: 'Pick up is too far' },
                { value: 'Issues with this patient or facility' },
                { value: 'Other' },
            ],
            comments: '',
            biddingAmount: 0,
            otherRejectionReason: '',
            cancelationReason: '',
            showCancelationReasonModal: false,
            showRejectionReasonModal: false,
        };
    },
    validations() {
        const validations = {
            rejectionReason: {
                required,
            },
            otherRejectionReason: {
                required,
            },
            cancelationReason: {
                required,
            },
        };
        if (!this.$data.showRejectionReasonModal) {
            delete validations.otherRejectionReason;
            delete validations.rejectionReason;
        }
        if (this.$data.rejectionReason !== 'Other') {
            delete validations.otherRejectionReason;
        }
        if (!this.$data.showCancelationReasonModal) {
            delete validations.cancelationReason;
        }
        return validations;
    },
    watch: {
        'id'(newId) {
            const obj = this as ServiceRequestDetails;
            obj.getRequestDetails();
        },
        '$route.path'(to, from) {
            const obj = this as ServiceRequestDetails;
            obj.getRequestDetails();
        },
    },
})
export default class ServiceRequestDetails extends Vue {

    private serviceRequest: ServiceRequest | any = '';
    private DateUtils = DateUtils;
    private rejectEvent = false;
    private rejectionReason = null;
    private showCompleteModal = false;
    private showCompleteHealthCareModal = false;
    private showCompleteCmrModal = false;
    private showAcceptedRoutesModal = false;
    private showAcceptBox = false;
    private MathUtils = MathUtils;
    private currentStatus: RequestStatus = 'Pending';
    private requestStatusArray: RequestStatus[] = [];
    private currentStatusTimestamp = 0;
    private currentStatusIndex: number = 0;
    private showInvoice = false;
    private showAcceptRequestModal = false;
    private routes: any[] = [];
    private showAssignDriverModal = false;
    private showCompleteRouteModal = false;
    private mapRoutes: Route[] = [];
    private routeId: string | undefined = '';
    private sessionInfo = ObjectFactory.getCacheService().getSessionInfo();
    private isCNA = false;
    private showTrackLocation = false;
    private driverLocation: GPSLocation | undefined = undefined;
    private remainingDistance: number | undefined = undefined;
    private duration: string | undefined = undefined;
    private estimatedArrivalTime: string | undefined = undefined;
    private isAuctionOpen = false;
    private overlapRequest: ServiceRequest | null = null;
    private isStatusPendingVerification = false;
    private cancelationReason = null;
    private cancelEvent = false;
    private interpreterProfile: InterpreterProfile = {} as any;
    private showEditInterpreterNameModal = false;
    private editedInterpreterFullname = '';
    private isChildInterpreter = false;
    private showAssignInterpreterModal = false;
    private confirmationBox = false;
    private transporterId = '';
    private isLegAssignedToPartner = false;
    private isImmediateWheelchairOrStretcher = false;

    public async mounted() {
        if (!this.isStatusPendingVerification) {
             this.getRequestDetails();
        }
        const status = ObjectFactory.getCacheService().getSessionInfo().status;
        if (status === 'PENDING_VERIFICATION') {
            this.isStatusPendingVerification = true;
        }
        const partnerService = ObjectFactory.getPartnerService();
        const partner = await partnerService.getPartnerProfile(this.$store.state.serverUrl);
        if (partner.data && partner.data.transporterProfile) {
            const transporter = partner.data.transporterProfile;
            if (transporter.transporterId) {
                this.transporterId = transporter.id;
            }
            if (transporter.roles && transporter.roles.includes('CNA')) {
                this.isCNA = true;
            }
        }
        if (partner.data && partner.data.interpreterProfile) {
            if (this.$store.state.isChildInterpreter) {
                this.isChildInterpreter = true;
            }
        }
    }

    private showCompleteRequestModal() {
        this.showCompleteModal = true;
    }

   private showCompleteHomeHealthCareRequestModal() {
        this.showCompleteHealthCareModal = true;
    }
    private showCompleteCmrRequestModal() {
        this.showCompleteCmrModal = true;
    }

    private async getRequestDetails() {
        this.showInvoice = false;
        this.routes = [];
        this.mapRoutes = [];
        const id = this.$props.id || this.$route.params.id;
        const response = await ObjectFactory.getRequestService().getRequestDetails(id, this.$store.state.serverUrl);
        this.serviceRequest = response.data;
        if (this.serviceRequest.deliveryRequest) {
            this.mapRoutes = this.serviceRequest.deliveryRequest.mapRoutes;
        }
        if (response.data && response.data.interpreterRequest && response.data.assignment.interpreterId) {
            const interpreterId = response.data.assignment.interpreterId;
            const iHttpService = ObjectFactory.getHttpService();
            const apiRequest: ApiRequest = {
                baseURL: this.$store.state.serverUrl,
                url: `${MedTransGoConstants.HTTP_URL_INTERPRETERS}/${interpreterId}`,
            };
            const interpreterResponse = await iHttpService.get<InterpreterProfile>(apiRequest);
            if (interpreterResponse.success && interpreterResponse.data) {
                this.interpreterProfile = interpreterResponse.data;
            } else {
                CommonUtils.showError(interpreterResponse);
            }
        }
        if (response.data && response.data.transportRequest) {
            if (response.data.assignment && response.data.assignment.transporters &&
                response.data.assignment.transporters.includes(this.transporterId) && response.data.status === 'Confirmed') {
                this.isLegAssignedToPartner = true;
            } else {
                this.isLegAssignedToPartner = false;
            }
            this.isImmediateWheelchairOrStretcher =
                response.data.transportRequest.isImmediateRequest
                && (response.data.transportRequest.vehicleType === 'Wheelchair'
                    || response.data.transportRequest.vehicleType === 'Stretcher');
            this.mapRoutes = this.serviceRequest.transportRequest.mapRoutes;
            response.data.transportRequest.mentalHealth =
                response.data.transportRequest.mentalHealth ? 'Yes' : 'No' as any;
            response.data.transportRequest.isOxygenTankRequired =
                response.data.transportRequest.isOxygenTankRequired ? 'Yes' : 'No' as any;
            response.data.transportRequest.isBariatricServiceRequired =
                response.data.transportRequest.isBariatricServiceRequired ? 'Yes' : 'No' as any;
            response.data.transportRequest.isWheelchairProvided =
                response.data.transportRequest.isWheelchairProvided ? 'Yes' : 'No' as any;
            response.data.transportRequest.caregiver =
                response.data.transportRequest.caregiver ? 'Yes' : 'No' as any;
            if (response.data.assignment.auction) {
                if (response.data.status === 'Pending' &&
                    DateUtils.getCurrentTimeInMillis() < response.data.assignment.auction.closeTime) {
                    this.isAuctionOpen = true;
                } else {
                    this.isAuctionOpen = false;
                }
                if (response.data.assignment.auction.bids.length > 0 && this.isAuctionOpen) {
                    this.$data.biddingAmount = 0;
                    const currentBids = response.data.assignment.auction.bids.
                        filter((bid) => bid.transporterId === this.sessionInfo.id);
                    const bids = currentBids.sort((bid1, bid2) => bid1.amount < bid2.amount ? -1 : 1);
                    this.$data.biddingAmount = MathUtils.formatCurrency(bids[0].amount);
                } else {
                    this.$data.biddingAmount = 0;
                }
            }
            for (const route of this.mapRoutes) {
                if (route.pickupAddress.pickupInstructionImageResourceId) {
                    route.pickupAddress.pickupInstructionImageResourceId =
                        await this.getResource(route.pickupAddress.pickupInstructionImageResourceId);
                }
                if (route.dropoffAddress.dropoffInstructionImageResourceId) {
                    route.dropoffAddress.dropoffInstructionImageResourceId =
                        await this.getResource(route.dropoffAddress.dropoffInstructionImageResourceId);
                }
                if (route.status === 'In-Progress' && route.tripDetails) {
                    this.showTrackLocation = true;
                    this.routeId = route.id;
                    this.driverLocation = {
                        latitude: route.tripDetails.driverLocation.latitude,
                        longitude: route.tripDetails.driverLocation.longitude,
                    };
                    this.remainingDistance = route.tripDetails.remainingDistance;
                    this.estimatedArrivalTime = DateUtils.formatDate(DateUtils.getCurrentTimeInMillis() +
                        route.tripDetails.duration);
                    this.duration = DateUtils.getDurationText(DateUtils.convertMillisToMinutes(
                        route.tripDetails.duration));
                    setInterval(this.trackDriverLocation, 20000);
                    break;
                } else {
                    this.showTrackLocation = false;
                }
            }
            if (response.data.status === 'Pending' && this.$route.query.accept
                && this.$route.query.accept === 'show') {
                this.showAcceptRequestModal = true;
            }
        }
    }

    private async trackDriverLocation() {
        if (this.showTrackLocation) {
            const apiRequest: ApiRequest = {
                baseURL: this.$store.state.serverUrl,
                url: `${MedTransGoConstants.HTTP_URL_ROUTES}/${this.routeId}`,
            };
            const iHttpService = ObjectFactory.getHttpService();
            const response = await iHttpService.get<Route>(apiRequest);
            if (response.success && response.data) {
                const route = response.data;
                if (route.status === 'In-Progress' && route.tripDetails) {
                    const googleMap = this.$refs.liveLocationMap as any;
                    googleMap.updateLocation(route.tripDetails.driverLocation);
                    this.remainingDistance = route.tripDetails.remainingDistance;
                    this.estimatedArrivalTime = DateUtils.formatDate(DateUtils.getCurrentTimeInMillis() +
                        route.tripDetails.duration);
                    this.duration = DateUtils.getDurationText(DateUtils.convertMillisToMinutes(
                        route.tripDetails.duration));
                } else {
                    this.remainingDistance = undefined;
                    this.duration = undefined;
                    this.estimatedArrivalTime = undefined;
                    this.driverLocation = undefined;
                }
            }
        }
    }

    private async acceptRequest() {
        if ((this.serviceRequest.transportRequest || this.serviceRequest.deliveryRequest) && !this.isCNA) {
            this.showAcceptRequestModal = true;
        }
        if (this.serviceRequest.homeAssistanceRequest && this.isCNA) {
            const id = this.$props.id || this.$route.params.id;
            const response = await ObjectFactory.getRequestService().acceptRequest(id, this.$store.state.serverUrl);
            if (response.success) {
                await this.getRequestDetails();
                this.showAcceptBox = true;
            }
        }
        if (this.serviceRequest.homeHealthCareRequest) {
                const id = this.$props.id || this.$route.params.id;
                const response = await ObjectFactory.getRequestService().acceptRequest(id, this.$store.state.serverUrl);
                if (response.success) {
                    await this.getRequestDetails();
                    this.showAcceptBox = true;
                }
        }
        if (this.serviceRequest.cmrRequest) {
            const id = this.$props.id || this.$route.params.id;
            const response = await ObjectFactory.getRequestService().acceptRequest(id, this.$store.state.serverUrl);
            if (response.success) {
                await this.getRequestDetails();
                this.showAcceptBox = true;
            }
        }
        if (this.serviceRequest.interpreterRequest) {
            const id = this.$props.id || this.$route.params.id;
            const response = await ObjectFactory.getRequestService().acceptRequest(id, this.$store.state.serverUrl);
            if (response.success) {
                await this.getRequestDetails();
                this.showAcceptBox = true;
            } else if (response.data) {
                this.overlapRequest = response.data;
            }
        }
    }
    private async bidRequest() {
        const id = this.$props.id || this.$route.params.id;
        this.$router.push({ path: `${MedTransGoConstants.URL_REQUESTS}/${id}/bidNow` });
    }

    private async rejectRequest() {
        const id = this.$props.id || this.$route.params.id;
        let rejectionReason = this.$data.rejectionReason;
        if (rejectionReason === 'Other') {
            rejectionReason = this.$data.otherRejectionReason;
        }
        await ObjectFactory.getRequestService().rejectRequest(id, this.$store.state.serverUrl, rejectionReason);
        this.$router.push({ path: `/requests`});
    }

    private async cancelRequest() {
        const iHttpService = ObjectFactory.getHttpService();
        const requestId = this.$props.id || this.$route.params.id;
        const cancelRequest = {
            reason: this.$data.cancelationReason,
            transporterId: this.transporterId,
        };
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_REQUEST}/${requestId}/revoke`,
            data: cancelRequest,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.put<any>(apiRequest);
        if (response.success) {
            if (this.serviceRequest.transportRequest) {
                const toastEvent: ToastEvent = {
                message: 'Request has been canceled from transporter successfully.',
                title: 'Success',
                varient: 'primary',
                timeout: 5000,
            };
                EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            } else if (this.serviceRequest.interpreterRequest) {
                const toastEvent: ToastEvent = {
                message: 'Request has been canceled from interpreter successfully.',
                title: 'Success',
                varient: 'primary',
                timeout: 5000,
            };
                EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            }
        } else {
            CommonUtils.showError(response);
        }
        this.$data.showCancelationReasonModal = false;
        await this.getRequestDetails();
    }

    private async getResource(resourceId: string): Promise<any> {
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_RESOURCE}/${resourceId}`,
        };
        const response = await iHttpService.get<any>(apiRequest);
        if (response.success && response.data) {
            return response.data;
        }
    }

    private gotoRequests(id?: string) {
        this.showAcceptBox = false;
        if (this.serviceRequest && this.serviceRequest.homeHealthCareRequest) {
            this.$router.push({
                path: `${MedTransGoConstants.URL_REQUESTS}/${id}`,
                query: { requestType: 'homeHealthCareRequest', status: 'Confirmed' },
            });
            return;
        } else if (this.serviceRequest && this.serviceRequest.interpreterRequest) {
            this.$router.push({
                path: `${MedTransGoConstants.URL_REQUESTS}/${id}`,
                query: { requestType: 'interpreterRequest', status: 'Confirmed' },
            });
            return;
        } else if (this.serviceRequest && this.serviceRequest.transportRequest) {
            this.$router.push({
                path: `${MedTransGoConstants.URL_REQUESTS}/${id}`,
                query: { requestType: 'transportRequest', status: 'Confirmed' },
            });
            return;
        } else if (this.serviceRequest && this.serviceRequest.deliveryRequest) {
            this.$router.push({
                path: `${MedTransGoConstants.URL_REQUESTS}/${id}`,
                query: { requestType: 'deliveryRequest', status: 'Confirmed' },
            });
            return;
        }
        if (id) {
            this.$router.push({ path: `${MedTransGoConstants.URL_REQUESTS}/${id}` });
        } else {
            this.$router.push({ path: `${MedTransGoConstants.URL_REQUESTS}` });
        }
    }

    private openEditInterpreterNameModal(interpreterName: string) {
        this.showEditInterpreterNameModal = true;
        this.editedInterpreterFullname = interpreterName;
    }

    private async updateInterpreterFullname() {
        const requestId = this.$props.id || this.$route.params.id;
        this.showEditInterpreterNameModal = false;
        const iHttpService = ObjectFactory.getHttpService();
        const updaterequest = {
            interpreterName: this.editedInterpreterFullname,
        };
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_REQUEST}/${requestId}/updaterequest`,
            data: updaterequest,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.put<ServiceRequest>(apiRequest);
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: `Interpreter Name Updated Successfully`,
                title: 'Success',
                varient: 'success',
                timeout: 2000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            this.getRequestDetails();
        } else {
            CommonUtils.showError(response);
        }
    }

    private openAssignInterpreterModal() {
        this.showAssignInterpreterModal = true;
    }


    private close() {
        this.$emit('close');
    }

}
